import React from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {ComponenteToken} from "../../../../../components/ComponenteToken";
import {IconArrowBack1} from "../../../../../icons/IconArrowBack1";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const CorporativoOnboardingPhone = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();

  const handleButtonClick = () => {
    const currentParams = location.search;
    navigate(`/vxlab-onboarding_welcome-corporativo-mobile${currentParams}`);
  };

  return (
      <div className="screen-coporativo-phone">
        <div className="corporativo-4">
          <div className="molecula-stepper">
            <div className="content-4">
              <div className="numb">
                <div className="text-wrapper-8">1</div>
              </div>

              <div className="line" />
            </div>

            <div className="div-3">
              <div className="div-3">
                <div className="numb-2">
                  <div className="text-wrapper-9">2</div>
                </div>

                <div className="line" />
              </div>
            </div>

            <div className="div-3">
              <div className="div-3">
                <div className="numb-2">
                  <div className="text-wrapper-9">3</div>
                </div>

                <div className="line" />
              </div>
            </div>

            <div className="div-3">
              <div className="div-3">
                <div className="numb-2">
                  <div className="text-wrapper-9">4</div>
                </div>

                <div className="line" />
              </div>
            </div>

            <div className="div-3">
              <div className="div-3">
                <div className="numb-3">
                  <div className="text-wrapper-10">5</div>
                </div>

                <div className="line-2" />
              </div>
            </div>

            <div className="atomo-step-final-no">
              <div className="content-5">
                <div className="element-wrapper">
                  <div className="element-2">6</div>
                </div>
              </div>
            </div>
          </div>

          <div className="frame-8">
            <svg
                width={65}
                height={87}
                viewBox="0 0 65 87"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  d="M46 87L32.9261 73.3183C31.6913 72.0261 31.6913 69.9549 32.9261 68.6817L46 55L59.0739 68.6817C60.3087 69.9739 60.3087 72.0451 59.0739 73.3183L46 87Z"
                  fill={colors.septimo}
              />
              <path
                  d="M37.5 1.25H12.5C9.84875 1.25298 7.30694 2.3075 5.43222 4.18222C3.5575 6.05694 2.50298 8.59875 2.5 11.25V68.75C2.50298 71.4013 3.5575 73.9431 5.43222 75.8178C7.30694 77.6925 9.84875 78.747 12.5 78.75H37.5C40.1513 78.747 42.6931 77.6925 44.5678 75.8178C46.4425 73.9431 47.497 71.4013 47.5 68.75V11.25C47.497 8.59875 46.4425 6.05694 44.5678 4.18222C42.6931 2.3075 40.1513 1.25298 37.5 1.25ZM5 13.75H45V61.25H5V13.75ZM12.5 3.75H37.5C39.4885 3.75199 41.395 4.5428 42.8011 5.94889C44.2072 7.35498 44.998 9.26149 45 11.25H5C5.00199 9.26149 5.7928 7.35498 7.19889 5.94889C8.60498 4.5428 10.5115 3.75199 12.5 3.75ZM37.5 76.25H12.5C10.5115 76.248 8.60498 75.4572 7.19889 74.0511C5.7928 72.645 5.00199 70.7385 5 68.75V63.75H45V68.75C44.998 70.7385 44.2072 72.645 42.8011 74.0511C41.395 75.4572 39.4885 76.248 37.5 76.25Z"
                  fill={colors.secundario}
              />
              <path
                  d="M12.5 3.75H37.5C39.4885 3.75199 41.395 4.5428 42.8011 5.94889C44.2072 7.35498 44.998 9.26149 45 11.25H5C5.00199 9.26149 5.7928 7.35498 7.19889 5.94889C8.60498 4.5428 10.5115 3.75199 12.5 3.75Z"
                  fill={colors.sexto}
              />
              <path
                  d="M25 66.25C24.2583 66.25 23.5333 66.4699 22.9166 66.882C22.2999 67.294 21.8193 67.8797 21.5355 68.5649C21.2516 69.2502 21.1774 70.0042 21.3221 70.7316C21.4668 71.459 21.8239 72.1272 22.3484 72.6516C22.8728 73.1761 23.541 73.5333 24.2684 73.6779C24.9958 73.8226 25.7498 73.7484 26.4351 73.4645C27.1203 73.1807 27.706 72.7001 28.118 72.0834C28.5301 71.4667 28.75 70.7417 28.75 70C28.75 69.0054 28.3549 68.0516 27.6517 67.3484C26.9484 66.6451 25.9946 66.25 25 66.25ZM25 71.25C24.7528 71.25 24.5111 71.1767 24.3055 71.0393C24.1 70.902 23.9398 70.7068 23.8452 70.4784C23.7505 70.2499 23.7258 69.9986 23.774 69.7561C23.8223 69.5137 23.9413 69.2909 24.1161 69.1161C24.2909 68.9413 24.5137 68.8222 24.7561 68.774C24.9986 68.7258 25.2499 68.7505 25.4784 68.8452C25.7068 68.9398 25.902 69.1 26.0393 69.3055C26.1767 69.5111 26.25 69.7528 26.25 70C26.25 70.3315 26.1183 70.6495 25.8839 70.8839C25.6495 71.1183 25.3315 71.25 25 71.25Z"
                  fill={colors.secundario}
              />
              <path
                  d="M28.75 6.25H21.25C20.9185 6.25 20.6005 6.3817 20.3661 6.61612C20.1317 6.85054 20 7.16848 20 7.5C20 7.83152 20.1317 8.14946 20.3661 8.38388C20.6005 8.6183 20.9185 8.75 21.25 8.75H28.75C29.0815 8.75 29.3995 8.6183 29.6339 8.38388C29.8683 8.14946 30 7.83152 30 7.5C30 7.16848 29.8683 6.85054 29.6339 6.61612C29.3995 6.3817 29.0815 6.25 28.75 6.25Z"
                  fill={colors.secundario}
              />
            </svg>

            <div className="frame-wrapper">
              <div className="frame-9">
                <p className="subtitle-9">
                <span className="span">
                  A validation code has been sent to&nbsp;&nbsp;
                  <br />
                </span>

                  <span className="text-wrapper-11">+54 9 1122 6476</span>
                </p>
              </div>
            </div>

            <ComponenteToken
                active={false}
                atomoTimeRectangleClassName="componente-token-5"
                atomoTimeSubtitleCopyClassName="componente-token-3"
                atomoTimeSubtitleCopyClassNameOverride="componente-token-3"
                atomoTimeTimelineClassName="componente-token-4"
                buttonActive
                buttonInactive={false}
                buttonSmallEstado="inactivo"
                buttonSmallTextClassName="componente-token-6"
                buttonSmallTexto="Resend code"
                className="componente-token-input"
                default1
                error={false}
                moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName="componente-token-input-instance"
                moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName1="componente-token-input-instance"
                moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName2="componente-token-input-instance"
                moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassNameOverride="componente-token-input-instance"
                moleculaTokenNumbsAtomoNumbTokenDivClassName="componente-token-instance"
                moleculaTokenNumbsAtomoNumbTokenDivClassNameOverride="componente-token-instance"
                moleculaTokenNumbsAtomoNumbTokenElementClassName="componente-token-instance"
                moleculaTokenNumbsAtomoNumbTokenElementClassName1="componente-token-instance"
                moleculaTokenNumbsAtomoNumbTokenElementClassName2="componente-token-instance"
                moleculaTokenNumbsAtomoNumbTokenElementClassNameOverride="componente-token-instance"
                moleculaTokenNumbsAtomoNumbTokenElementWrapperClassName="componente-token-input-instance"
                moleculaTokenNumbsAtomoNumbTokenElementWrapperClassNameOverride="componente-token-input-instance"
                moleculaTokenNumbsAtomoNumbTokenText="8"
                moleculaTokenNumbsAtomoNumbTokenText1="4"
                moleculaTokenNumbsAtomoNumbTokenText2="9"
                moleculaTokenNumbsAtomoNumbTokenText3="6"
                moleculaTokenNumbsDefaultFalseActiveClassName="componente-token-2"
            />
          </div>

          <div className="action-buttons-2 highlighted-button">
            <div className="test-button-3 " onClick={handleButtonClick}>
              <div className="text-wrapper-12">Validate</div>
            </div>
          </div>

          <header className="header-2">
            <div className="overlap-8">
              <div className="group-10">
                <div className="group-11">
                  <div className="overlap-group-4">
                    <div className="rectangle-5" />
                    <div className="frame-10">
                      <svg
                          width={180}
                          height={170}
                          viewBox="0 0 200 190"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M204.536 85.2019L203.169 83.8348L204.536 82.4676L205.903 83.8348L204.536 85.2019Z"
                            fill="#F2F3F7"
                            fillOpacity={0.05}
                        />
                        <path
                            d="M204.536 108.113L203.169 106.746L204.536 105.379L205.903 106.746L204.536 108.113Z"
                            fill="#F2F3F7"
                            fillOpacity={0.1}
                        />
                        <path
                            d="M204.536 128.29L203.169 129.657L204.536 131.025L205.903 129.657L204.536 128.29Z"
                            fill="#F2F3F7"
                            fillOpacity={0.1}
                        />
                        <path
                            d="M204.536 151.201L203.169 152.569L204.536 153.936L205.903 152.569L204.536 151.201Z"
                            fill="#F2F3F7"
                            fillOpacity={0.05}
                        />
                        <path
                            d="M184.219 62.2908L182.852 60.9236L184.219 59.5565L185.586 60.9236L184.219 62.2908Z"
                            fill="#F2F3F7"
                            fillOpacity={0.1}
                        />
                        <path
                            d="M184.219 85.2019L182.852 83.8348L184.219 82.4676L185.586 83.8348L184.219 85.2019Z"
                            fill="#F2F3F7"
                            fillOpacity={0.15}
                        />
                        <path
                            d="M184.219 108.113L182.852 106.746L184.219 105.379L185.586 106.746L184.219 108.113Z"
                            fill="#F2F3F7"
                            fillOpacity={0.2}
                        />
                        <path
                            d="M184.219 128.29L182.852 129.657L184.219 131.025L185.586 129.657L184.219 128.29Z"
                            fill="#F2F3F7"
                            fillOpacity={0.15}
                        />
                        <path
                            d="M184.219 151.201L182.852 152.569L184.219 153.936L185.586 152.569L184.219 151.201Z"
                            fill="#F2F3F7"
                            fillOpacity={0.1}
                        />
                        <path
                            d="M184.219 174.113L182.852 175.48L184.219 176.847L185.586 175.48L184.219 174.113Z"
                            fill="#F2F3F7"
                            fillOpacity={0.05}
                        />
                        <path
                            d="M163.902 39.3794L162.535 38.0122L163.902 36.6451L165.27 38.0122L163.902 39.3794Z"
                            fill="#F2F3F7"
                            fillOpacity={0.05}
                        />
                        <path
                            d="M163.902 62.2908L162.535 60.9236L163.902 59.5565L165.27 60.9236L163.902 62.2908Z"
                            fill="#F2F3F7"
                            fillOpacity={0.15}
                        />
                        <path
                            d="M163.902 85.2019L162.535 83.8348L163.902 82.4676L165.27 83.8348L163.902 85.2019Z"
                            fill="#F2F3F7"
                            fillOpacity={0.2}
                        />
                        <path
                            d="M163.902 108.113L162.535 106.746L163.902 105.379L165.27 106.746L163.902 108.113Z"
                            fill="#F2F3F7"
                            fillOpacity={0.25}
                        />
                        <path
                            d="M163.902 128.29L162.535 129.657L163.902 131.025L165.27 129.657L163.902 128.29Z"
                            fill="#F2F3F7"
                            fillOpacity={0.2}
                        />
                        <path
                            d="M163.902 151.201L162.535 152.569L163.902 153.936L165.27 152.569L163.902 151.201Z"
                            fill="#F2F3F7"
                            fillOpacity={0.15}
                        />
                        <path
                            d="M163.902 174.113L162.535 175.48L163.902 176.847L165.27 175.48L163.902 174.113Z"
                            fill="#F2F3F7"
                            fillOpacity={0.1}
                        />
                        <path
                            d="M143.585 16.468L142.218 15.1009L143.585 13.7337L144.952 15.1009L143.585 16.468Z"
                            fill="#F2F3F7"
                            fillOpacity={0.05}
                        />
                        <path
                            d="M143.585 39.3794L142.218 38.0122L143.585 36.6451L144.952 38.0122L143.585 39.3794Z"
                            fill="#F2F3F7"
                            fillOpacity={0.2}
                        />
                        <path
                            d="M143.585 62.2908L142.218 60.9236L143.585 59.5565L144.952 60.9236L143.585 62.2908Z"
                            fill="#F2F3F7"
                            fillOpacity={0.35}
                        />
                        <path
                            d="M143.585 85.2019L142.218 83.8348L143.585 82.4676L144.952 83.8348L143.585 85.2019Z"
                            fill="#F2F3F7"
                            fillOpacity={0.45}
                        />
                        <path
                            d="M143.585 108.113L142.218 106.746L143.585 105.379L144.952 106.746L143.585 108.113Z"
                            fill="#F2F3F7"
                            fillOpacity={0.5}
                        />
                        <path
                            d="M143.585 128.29L142.218 129.657L143.585 131.025L144.952 129.657L143.585 128.29Z"
                            fill="#F2F3F7"
                            fillOpacity={0.4}
                        />
                        <path
                            d="M143.585 151.201L142.218 152.569L143.585 153.936L144.952 152.569L143.585 151.201Z"
                            fill="#F2F3F7"
                            fillOpacity={0.3}
                        />
                        <path
                            d="M143.585 174.113L142.218 175.48L143.585 176.847L144.952 175.48L143.585 174.113Z"
                            fill="#F2F3F7"
                            fillOpacity={0.2}
                        />
                        <path
                            d="M123.269 16.468L121.901 15.1009L123.269 13.7337L124.636 15.1009L123.269 16.468Z"
                            fill="#F2F3F7"
                            fillOpacity={0.15}
                        />
                        <path
                            d="M123.269 39.3794L121.901 38.0122L123.269 36.6451L124.636 38.0122L123.269 39.3794Z"
                            fill="#F2F3F7"
                            fillOpacity={0.35}
                        />
                        <path
                            d="M123.269 62.2908L121.901 60.9236L123.269 59.5565L124.636 60.9236L123.269 62.2908Z"
                            fill="#F2F3F7"
                            fillOpacity={0.5}
                        />
                        <path
                            d="M123.269 85.2019L121.901 83.8348L123.269 82.4676L124.636 83.8348L123.269 85.2019Z"
                            fill="#F2F3F7"
                            fillOpacity={0.65}
                        />
                        <path
                            d="M123.269 108.113L121.901 106.746L123.269 105.379L124.636 106.746L123.269 108.113Z"
                            fill="#F2F3F7"
                            fillOpacity={0.6}
                        />
                        <path
                            d="M123.269 128.29L121.901 129.657L123.269 131.025L124.636 129.657L123.269 128.29Z"
                            fill="#F2F3F7"
                            fillOpacity={0.55}
                        />
                        <path
                            d="M123.269 151.201L121.901 152.569L123.269 153.936L124.636 152.569L123.269 151.201Z"
                            fill="#F2F3F7"
                            fillOpacity={0.4}
                        />
                        <path
                            d="M123.269 174.113L121.901 175.48L123.269 176.847L124.636 175.48L123.269 174.113Z"
                            fill="#F2F3F7"
                            fillOpacity={0.25}
                        />
                        <path
                            d="M102.951 16.468L101.584 15.1009L102.951 13.7337L104.318 15.1009L102.951 16.468Z"
                            fill="#F2F3F7"
                            fillOpacity={0.3}
                        />
                        <path
                            d="M102.951 39.3794L101.584 38.0122L102.951 36.6451L104.318 38.0122L102.951 39.3794Z"
                            fill="#F2F3F7"
                            fillOpacity={0.55}
                        />
                        <path
                            d="M102.951 62.2908L101.584 60.9236L102.951 59.5565L104.318 60.9236L102.951 62.2908Z"
                            fill="#F2F3F7"
                            fillOpacity={0.75}
                        />
                        <path
                            d="M102.951 85.2019L101.584 83.8348L102.951 82.4676L104.318 83.8348L102.951 85.2019Z"
                            fill="#F2F3F7"
                            fillOpacity={0.8}
                        />
                        <path
                            d="M102.951 108.113L101.584 106.746L102.951 105.379L104.318 106.746L102.951 108.113Z"
                            fill="#F2F3F7"
                            fillOpacity={0.7}
                        />
                        <path
                            d="M102.951 128.29L101.584 129.657L102.951 131.025L104.318 129.657L102.951 128.29Z"
                            fill="#F2F3F7"
                            fillOpacity={0.6}
                        />
                        <path
                            d="M102.951 151.201L101.584 152.569L102.951 153.936L104.318 152.569L102.951 151.201Z"
                            fill="#F2F3F7"
                            fillOpacity={0.5}
                        />
                        <path
                            d="M102.951 174.113L101.584 175.48L102.951 176.847L104.318 175.48L102.951 174.113Z"
                            fill="#F2F3F7"
                            fillOpacity={0.35}
                        />
                        <path
                            d="M82.6348 16.468L81.2677 15.1009L82.6348 13.7337L84.002 15.1009L82.6348 16.468Z"
                            fill="#F2F3F7"
                            fillOpacity={0.4}
                        />
                        <path
                            d="M82.6348 39.3794L81.2677 38.0122L82.6348 36.6451L84.002 38.0122L82.6348 39.3794Z"
                            fill="#F2F3F7"
                            fillOpacity={0.65}
                        />
                        <path
                            d="M82.6348 62.2908L81.2677 60.9236L82.6348 59.5565L84.002 60.9236L82.6348 62.2908Z"
                            fill="#F2F3F7"
                            fillOpacity={0.9}
                        />
                        <path
                            d="M82.6348 85.2019L81.2677 83.8348L82.6348 82.4676L84.002 83.8348L82.6348 85.2019Z"
                            fill="#F2F3F7"
                        />
                        <path
                            d="M82.6348 108.113L81.2677 106.746L82.6348 105.379L84.002 106.746L82.6348 108.113Z"
                            fill="#F2F3F7"
                            fillOpacity={0.9}
                        />
                        <path
                            d="M82.6348 128.29L81.2677 129.657L82.6348 131.025L84.002 129.657L82.6348 128.29Z"
                            fill="#F2F3F7"
                            fillOpacity={0.8}
                        />
                        <path
                            d="M82.6348 151.201L81.2677 152.569L82.6348 153.936L84.002 152.569L82.6348 151.201Z"
                            fill="#F2F3F7"
                            fillOpacity={0.6}
                        />
                        <path
                            d="M82.6348 174.113L81.2677 175.48L82.6348 176.847L84.002 175.48L82.6348 174.113Z"
                            fill="#F2F3F7"
                            fillOpacity={0.45}
                        />
                        <path
                            d="M62.3174 16.468L60.9503 15.1009L62.3174 13.7337L63.6846 15.1009L62.3174 16.468Z"
                            fill="#F2F3F7"
                            fillOpacity={0.5}
                        />
                        <path
                            d="M62.3174 39.3794L60.9503 38.0122L62.3174 36.6451L63.6846 38.0122L62.3174 39.3794Z"
                            fill="#F2F3F7"
                            fillOpacity={0.7}
                        />
                        <path
                            d="M62.3174 62.2908L60.9503 60.9236L62.3174 59.5565L63.6846 60.9236L62.3174 62.2908Z"
                            fill="#F2F3F7"
                            fillOpacity={0.8}
                        />
                        <path
                            d="M62.3174 85.2019L60.9503 83.8348L62.3174 82.4676L63.6846 83.8348L62.3174 85.2019Z"
                            fill="#F2F3F7"
                            fillOpacity={0.9}
                        />
                        <path
                            d="M62.3174 108.113L60.9503 106.746L62.3174 105.379L63.6846 106.746L62.3174 108.113Z"
                            fill="#F2F3F7"
                        />
                        <path
                            d="M62.3174 128.29L60.9503 129.657L62.3174 131.025L63.6846 129.657L62.3174 128.29Z"
                            fill="#F2F3F7"
                            fillOpacity={0.9}
                        />
                        <path
                            d="M62.3174 151.201L60.9503 152.569L62.3174 153.936L63.6846 152.569L62.3174 151.201Z"
                            fill="#F2F3F7"
                            fillOpacity={0.8}
                        />
                        <path
                            d="M62.3174 174.113L60.9503 175.48L62.3174 176.847L63.6846 175.48L62.3174 174.113Z"
                            fill="#F2F3F7"
                            fillOpacity={0.5}
                        />
                        <path
                            d="M42.001 16.468L40.6339 15.1009L42.001 13.7337L43.3682 15.1009L42.001 16.468Z"
                            fill="#F2F3F7"
                            fillOpacity={0.5}
                        />
                        <path
                            d="M42.001 39.3794L40.6339 38.0122L42.001 36.6451L43.3682 38.0122L42.001 39.3794Z"
                            fill="#F2F3F7"
                            fillOpacity={0.7}
                        />
                        <path
                            d="M42.001 62.2908L40.6339 60.9236L42.001 59.5565L43.3682 60.9236L42.001 62.2908Z"
                            fill="#F2F3F7"
                            fillOpacity={0.8}
                        />
                        <path
                            d="M42.001 85.2019L40.6339 83.8348L42.001 82.4676L43.3682 83.8348L42.001 85.2019Z"
                            fill="#F2F3F7"
                            fillOpacity={0.9}
                        />
                        <path
                            d="M42.001 108.113L40.6339 106.746L42.001 105.379L43.3682 106.746L42.001 108.113Z"
                            fill="#F2F3F7"
                        />
                        <path
                            d="M42.001 128.29L40.6339 129.657L42.001 131.025L43.3682 129.657L42.001 128.29Z"
                            fill="#F2F3F7"
                            fillOpacity={0.9}
                        />
                        <path
                            d="M42.001 151.201L40.6339 152.569L42.001 153.936L43.3682 152.569L42.001 151.201Z"
                            fill="#F2F3F7"
                            fillOpacity={0.8}
                        />
                        <path
                            d="M42.001 174.113L40.6339 175.48L42.001 176.847L43.3682 175.48L42.001 174.113Z"
                            fill="#F2F3F7"
                            fillOpacity={0.7}
                        />
                        <path
                            d="M21.6836 16.468L20.3165 15.1009L21.6836 13.7337L23.0508 15.1009L21.6836 16.468Z"
                            fill="#F2F3F7"
                            fillOpacity={0.5}
                        />
                        <path
                            d="M21.6836 39.3794L20.3165 38.0122L21.6836 36.6451L23.0508 38.0122L21.6836 39.3794Z"
                            fill="#F2F3F7"
                            fillOpacity={0.7}
                        />
                        <path
                            d="M21.6836 62.2908L20.3165 60.9236L21.6836 59.5565L23.0508 60.9236L21.6836 62.2908Z"
                            fill="#F2F3F7"
                            fillOpacity={0.8}
                        />
                        <path
                            d="M21.6836 85.2019L20.3165 83.8348L21.6836 82.4676L23.0508 83.8348L21.6836 85.2019Z"
                            fill="#F2F3F7"
                            fillOpacity={0.9}
                        />
                        <path
                            d="M21.6836 108.113L20.3165 106.746L21.6836 105.379L23.0508 106.746L21.6836 108.113Z"
                            fill="#F2F3F7"
                        />
                        <path
                            d="M21.6836 128.29L20.3165 129.657L21.6836 131.025L23.0508 129.657L21.6836 128.29Z"
                            fill="#F2F3F7"
                            fillOpacity={0.9}
                        />
                        <path
                            d="M21.6836 151.201L20.3165 152.569L21.6836 153.936L23.0508 152.569L21.6836 151.201Z"
                            fill="#F2F3F7"
                            fillOpacity={0.8}
                        />
                        <path
                            d="M21.6836 174.113L20.3165 175.48L21.6836 176.847L23.0508 175.48L21.6836 174.113Z"
                            fill="#F2F3F7"
                            fillOpacity={0.7}
                        />
                        <path
                            d="M1.36625 16.468L-0.00089407 15.1009L1.36625 13.7337L2.7334 15.1009L1.36625 16.468Z"
                            fill="#F2F3F7"
                            fillOpacity={0.7}
                        />
                        <path
                            d="M1.36625 39.3794L-0.00089407 38.0122L1.36625 36.6451L2.7334 38.0122L1.36625 39.3794Z"
                            fill="#F2F3F7"
                            fillOpacity={0.8}
                        />
                        <path
                            d="M1.36625 62.2908L-0.00089407 60.9236L1.36625 59.5565L2.7334 60.9236L1.36625 62.2908Z"
                            fill="#F2F3F7"
                            fillOpacity={0.9}
                        />
                        <path
                            d="M1.36625 85.2019L-0.00089407 83.8348L1.36625 82.4676L2.7334 83.8348L1.36625 85.2019Z"
                            fill="#F2F3F7"
                            fillOpacity={0.9}
                        />
                        <path
                            d="M1.36625 108.113L-0.00089407 106.746L1.36625 105.379L2.7334 106.746L1.36625 108.113Z"
                            fill="#F2F3F7"
                        />
                        <path
                            d="M1.36625 128.29L-0.00089407 129.657L1.36625 131.025L2.7334 129.657L1.36625 128.29Z"
                            fill="#F2F3F7"
                        />
                        <path
                            d="M1.36625 151.201L-0.00089407 152.569L1.36625 153.936L2.7334 152.569L1.36625 151.201Z"
                            fill="#F2F3F7"
                        />
                        <path
                            d="M1.36625 174.113L-0.00089407 175.48L1.36625 176.847L2.7334 175.48L1.36625 174.113Z"
                            fill="#F2F3F7"
                            fillOpacity={0.9}
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>

              <div className="frame-11">
                <div className="icon-arrow-back-wrapper">
                  <IconArrowBack1 className="icon-arrow-back-1" />
                </div>

                <div className="subtitle-10">Register Mobile number</div>
              </div>
            </div>
          </header>
        </div>
      </div>
  );
};
